import { injectLocal } from '@vueuse/core';
import { PRODUCT_PRICE_REPOSITORY } from '~/modules/product/constants/providers';

export const useProductPrice = () => {
  const selectedPrice = injectLocal(PRODUCT_PRICE_REPOSITORY);

  if (typeof selectedPrice === 'undefined') {
    throw new TypeError('useProductPrice() is called without provider');
  }

  return selectedPrice;
};
export default useProductPrice;
